<template>
    <section class="view">
        <PhotoChooser v-if="openPhotoChooser"
                      :multipleSelection="multipleSelection"
                      v-on:selection-finished="handleSelectionFinished($event)"/>

        <div class="container view-body view-body--padded"> <!-- _section-content-page -->
            <component :is="productItemConfigurator" ref="productItemConfigurator"></component>
        </div>
    </section>
</template>


<script>
    import PhotoChooser from '@/components/PhotoChooser.vue'
    import ProductItemConfiguratorPrint from '@/components/ProductItemConfiguratorPrint.vue'


    export default {
        props: ['printItemId'],
        // TODO: riattivare quando risolto problema Number/String
        // props: {
        //     printItemId: {type: Number},
        // },

        components: {
            PhotoChooser,
            ProductItemConfiguratorPrint
        },

        created() {
            this.$store.dispatch('cart/getCart')
                .then(() => {
                    if (this.printItemId) {
                        /*
                        * Edit di un prodotto già nel carrello
                        * */
                        const printItem = this.$store.getters['cart/getPrintItemById'](this.printItemId)
                        console.log('printItem', this.printItemId, printItem)

                        if (printItem === undefined) {
                            // non esiste alcun printItem col printItemId passato come argomento
                            this.$bvToast.toast(this.$t('notifications.item_not_found'), {variant: 'warning'})
                            this.$router.push({name: 'choose-product'})
                        }

                        this.$store.dispatch('prints/getProducts')
                            .then(response => {
                                console.warn("prints/getProducts", response.data)
                                // Note: we cannot use printItem.product, since it doesn't contain all the fields
                                const product = this.$store.getters['prints/getProductById'](printItem.product.id)
                                console.log('product', product)
                                const variantOptionFormat = printItem.product_variant_options[0]

                                this.$store.commit("prints/SET_PRODUCT_SELECTED", {
                                    productId: printItem.product.id,
                                    productVariantOptionFormat: variantOptionFormat
                                })

                                this.$refs.productItemConfigurator.loadFromPrintItem(printItem)
                            })
                    } else {
                        this.$refs.productItemConfigurator.showPhotoChooser()
                    }
                    /*
                    * Nuovo prodotto - se c'è selezionato un prodotto dallo step precedente - altrimenti
                    * redirect
                    * */
                    /*if (! this.$store.getters['prints/isProductSelected']) {
                        this.$router.push({name: "choose-product"})
                    }
                }*/
                })
        },

        computed: {
            openPhotoChooser() {
                return this.$store.getters['prints/isPhotoChooserOpen']
            },

            multipleSelection() {
                return this.$store.state.prints.photoChooserMultipleSelection
            },

            productItemConfigurator() {
                /*let configurator_type = ''
                if (this.$store.state.prints.selectedProduct.configurator_type) {
                    configurator_type = this.$store.state.prints.selectedProduct.configurator_type
                }
                console.log('loadedProductItemConfigurator configurator_type = ', configurator_type)*/

                // TODO: desumere dinamicamente dal tipo di prodotto (o dalla famiglia di prodotti print/homedecor?)
                // TODO: o dal product.family_tag
                const productFamily = 'Print'
                return `ProductItemConfigurator${productFamily}`
            }
        },

        methods: {
            // TODO: in teoria photos dovrebbe venire popolato dal cartPrintItem, se passato il printItemId
            handleSelectionFinished(photos) {
                this.$refs.productItemConfigurator.setAndDecoratePhotos(photos)
            }
        }
    }
</script>
